module.exports = __webpack_public_path__ + "img/open.6d94f3c9.svg";